<div class="cta-box" *ngIf="winnerMessage">
  <div class="mat-subtitle-4">
    <ui-linkified [text]="winnerMessage"></ui-linkified>
  </div>
</div>
